import { useDispatch, useSelector } from 'react-redux'
import { TimezonePicker as BaseTimezonePicker } from '@calendly/booking-kit'
import { TimezoneSelect } from '@calendly/timezone-tools/timezone-select'
import { parseQuery } from '@calendly/http-tools'

import { changeTimezone } from 'actions/timezone'
import { changeTimeNotation, updateSelectedSpotsByTimezone } from 'actions/calendar'
import { eventTypeSelector } from 'root-api'
import {
  timezoneSelector,
  timeNotationSelector
} from 'selectors'

export const TimezonePicker = ({ isFlatSpotpicker = false, variant = 'default' }) => {
  const dispatch = useDispatch()
  const expanded = !!parseQuery(window.location.search).timezone_picker
  const timezone = useSelector(timezoneSelector)
  const timeNotation = useSelector(timeNotationSelector)
  const { lock_timezone_enabled: timezoneLocked } = useSelector(eventTypeSelector)

  const onSelectTimezone = (tz) => {
    dispatch(changeTimezone(tz))
    dispatch(updateSelectedSpotsByTimezone(tz))
  }

  const onChangeTimeNotation = (notation) => dispatch(changeTimeNotation(notation))

  if (variant === 'minimal') {
    return (
      <TimezoneSelect
        variant="minimal"
        value={timezone}
        onChange={onSelectTimezone}
        placeholder="…"
        showTimezoneIcon
        timeNotation={timeNotation}
        onTimeNotationChange={onChangeTimeNotation}
        showTimeNotationToggle
        disabled={timezoneLocked}
        controlLabelFormat="short"
        dropdownPlacement="right"
      />
    )
  }

  return (
    <BaseTimezonePicker
      expanded={expanded}
      timezone={timezone}
      timeNotation={timeNotation}
      timezoneLocked={timezoneLocked}
      isFlatSpotpicker={isFlatSpotpicker}
      onSelectTimezone={onSelectTimezone}
      onChangeTimeNotation={onChangeTimeNotation}
    />
  )
}
